import tinycolor from "tinycolor2";
import { delay } from "../index";
import React from "react";
export function blurApp(blur) {
    const $kapp = $(".kapp");
    blur ? $kapp.addClass("blur") : $kapp.removeClass("blur");
}
export function closeDropdownMenu() {
    document.dispatchEvent(new MouseEvent("click"));
}
export async function blobToBase64(blob) {
    const fullB64 = await new Promise((resolve, _) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
    });
    return fullB64.split(",")[1];
}
export function stringify(obj) {
    if (obj) {
        if (typeof obj === "string") {
            return obj;
        }
        else {
            return JSON.stringify(obj);
        }
    }
    else {
        return "";
    }
}
export function coordinateInputValidation(validations, id, errorKeys, requiredValidation, fileValidations) {
    var _a, _b;
    const input = $(`#${id}`);
    const value = input.val() + "";
    validations = validations.filter((v) => !!v);
    fileValidations = fileValidations ? fileValidations.filter((v) => !!v) : [];
    input.get(0).setCustomValidity("");
    if (requiredValidation) {
        if (!requiredValidation(value, errorKeys)) {
            input.get(0).setCustomValidity("error");
            return;
        }
    }
    if ((_b = (_a = input[0]) === null || _a === void 0 ? void 0 : _a.validity) === null || _b === void 0 ? void 0 : _b.typeMismatch) {
        errorKeys === null || errorKeys === void 0 ? void 0 : errorKeys.push("type");
    }
    for (const validation of validations) {
        if (!validation(value, errorKeys)) {
            input.get(0).setCustomValidity("error");
            if (errorKeys) {
                errorKeys.push("validate");
            }
            return;
        }
    }
    for (const fileValidation of fileValidations || []) {
        if (!fileValidation(input.prop("files"), errorKeys)) {
            input.get(0).setCustomValidity("error");
            if (errorKeys) {
                errorKeys.push("validate");
            }
            return;
        }
    }
    input.get(0).setCustomValidity("");
}
export function checkGroupRequired(ids, errorMessageSelector) {
    const checks = ids.map((id) => $(`#${id}`));
    const values = checks.map((check) => check.prop("checked"));
    if (values.reduce((previousValue, currentValue) => previousValue || currentValue, false)) {
        checks.forEach((check) => {
            check.get(0).setCustomValidity("");
        });
        if (errorMessageSelector) {
            $(errorMessageSelector).css("display", "none");
        }
    }
    else {
        checks.forEach((check) => {
            check.get(0).setCustomValidity("error");
        });
        if (errorMessageSelector) {
            $(errorMessageSelector).css("display", "inline-block");
        }
    }
}
export function getPatterValidationFunc(pattern) {
    return pattern
        ? (value, errorKeys) => {
            const toReturn = !!value.match(new RegExp(pattern));
            if (!toReturn && errorKeys) {
                errorKeys.push("pattern");
            }
            return toReturn;
        }
        : undefined;
}
export function getMaxSizeValidationFunc(maxSize) {
    return maxSize
        ? (value, errorKeys) => {
            if (!value[0]) {
                return true;
            }
            const toReturn = Math.floor(value[0].size / 1024 ** 2) <= maxSize;
            if (!toReturn && errorKeys) {
                errorKeys.push("maxSize");
            }
            return toReturn;
        }
        : undefined;
}
export function getRequiredValidationFunc(required) {
    return required
        ? (value, errorKeys) => {
            const toReturn = !!value;
            if (!toReturn && errorKeys) {
                errorKeys.push("required");
            }
            return toReturn;
        }
        : undefined;
}
export var FontFamily;
(function (FontFamily) {
    FontFamily["TEXT"] = "KTextFont";
    FontFamily["DEFAULT"] = "KDefaultFont";
})(FontFamily || (FontFamily = {}));
export function getTextSize(text, fontSize, fontFamily = FontFamily.DEFAULT) {
    const element = document.createElement("span");
    document.body.appendChild(element);
    element.style.fontFamily = `${fontFamily}, sans-serif`;
    element.style.fontSize = typeof fontSize === "number" ? 16 + "px" : fontSize;
    element.style.height = "auto";
    element.style.width = "auto";
    element.style.position = "absolute";
    element.style.whiteSpace = "no-wrap";
    element.innerHTML = text;
    const width = Math.ceil(element.clientWidth);
    const height = Math.ceil(element.clientHeight);
    document.body.removeChild(element);
    return { width, height };
}
export function getTextSizeForId(id) {
    const element = document.getElementById(id);
    const width = Math.ceil((element === null || element === void 0 ? void 0 : element.clientWidth) || 0);
    const height = Math.ceil((element === null || element === void 0 ? void 0 : element.clientHeight) || 0);
    return { width, height };
}
export function def(val, defaultValue) {
    if (val === undefined) {
        return defaultValue;
    }
    else {
        return val;
    }
}
export function log(msg) {
    // tslint:disable-next-line:no-console
    console.log(msg);
}
export function tooBright(color) {
    const pColor = tinycolor(color);
    // Color will be considered too bright if it's luminance is greater than 0.72
    return pColor.getLuminance() > 0.45;
}
export function animateInfoButton(api) {
    function animateHeartbeat(count = 3) {
        api.start({
            from: {
                scale: 1,
            },
            to: async (next) => {
                const duration = 1.5 * 1000;
                await next({ scale: 1.3, transformOrigin: "50% 50%", color: "#5198f4", config: { duration: duration * 0.1 } });
                await next({ scale: 1.1, config: { duration: duration * 0.07 } });
                await next({ scale: 1.7, config: { duration: duration * 0.16 } });
                await next({ scale: 1, color: "#8c9ab1", config: { duration: duration * 0.12 } });
                await delay(1000);
            },
            onRest: () => {
                if (count > 1) {
                    animateHeartbeat(count - 1);
                }
            },
        });
    }
    api.start({
        from: {
            scale: 4,
            opacity: 0,
            transformOrigin: "100% 100%",
        },
        to: {
            scale: 1,
            opacity: 1,
            transformOrigin: "50% 50%",
        },
        config: { duration: 500, decay: true },
        onRest: () => {
            animateHeartbeat();
        },
    });
}
export var HelpModalIcon;
(function (HelpModalIcon) {
    HelpModalIcon["HELP"] = "fa-solid fa-circle-question";
    HelpModalIcon["INFO"] = "fal fa-info-circle";
})(HelpModalIcon || (HelpModalIcon = {}));
export async function getStatusPageData(componentId) {
    const res = await fetch("https://kopjra.statuspage.io/api/v2/incidents/unresolved.json");
    if (res.ok) {
        const data = await res.json();
        const incidents = data === null || data === void 0 ? void 0 : data.incidents;
        if (incidents) {
            for (const incident of incidents) {
                const component = componentId ? incident.components.find((c) => c.id === componentId) : incident.components[0];
                if (component) {
                    return {
                        status: incident.status,
                        name: incident.name,
                        updatedAt: incident.updated_at,
                        componentStatus: component.status === "partial_outage" ? "warning" : component.status === "major_outage" ? "danger" : "info",
                        url: incident.shortlink,
                    };
                }
            }
        }
    }
}
let fetchCacheTimeout;
export function useClearCache(duration = 30 * 1000) {
    const [loading, setLoading] = React.useState(true);
    const currentVersion = process.env.REACT_APP_VERSION;
    const [isLatestVersion, setIsLatestVersion] = React.useState(true);
    async function emptyCacheStorage() {
        if ("caches" in window) {
            // Service worker cache should be cleared with caches.delete()
            const cacheKeys = await window.caches.keys();
            await Promise.all(cacheKeys.map((key) => {
                window.caches.delete(key);
            }));
        }
        window.location.href = window.location.href;
        window.location.reload();
    }
    async function fetchMeta() {
        try {
            const response = await fetch("/meta.json", {
                cache: "no-store",
            });
            const meta = await response.json();
            const newVersion = meta.version;
            const isUpdated = newVersion === currentVersion;
            if (!isUpdated) {
                setLoading(false);
                setIsLatestVersion(false);
            }
            else {
                setIsLatestVersion(true);
                setLoading(false);
            }
        }
        catch (err) {
            console.error(err);
        }
    }
    React.useEffect(() => {
        fetchCacheTimeout = setInterval(() => fetchMeta(), duration);
        return () => {
            clearInterval(fetchCacheTimeout);
        };
    }, [loading]);
    const startVersionCheck = React.useRef(() => { });
    const stopVersionCheck = React.useRef(() => { });
    startVersionCheck.current = () => {
        if (window.navigator.onLine) {
            fetchCacheTimeout = setInterval(() => fetchMeta(), duration);
        }
    };
    stopVersionCheck.current = () => {
        clearInterval(fetchCacheTimeout);
    };
    React.useEffect(() => {
        window.addEventListener("focus", startVersionCheck.current);
        window.addEventListener("blur", stopVersionCheck.current);
        return () => {
            window.removeEventListener("focus", startVersionCheck.current);
            window.removeEventListener("blur", stopVersionCheck.current);
        };
    }, []);
    React.useEffect(() => {
        (async () => {
            await fetchMeta();
        })();
    }, []);
    return {
        loading,
        isLatestVersion,
        emptyCacheStorage,
    };
}
